<template>
<div class="container">
    <!-- <van-nav-bar :title="title" left-text="返回" left-arrow>
        <template #left>
            <van-icon color="#242934" name="arrow-left" @click="back"/>
            <van-icon color="#242934" name="cross" @click="quit" class="ml-10"/>
        </template>
        <template #right>
        </template>
    </van-nav-bar> -->
    <div v-if="result.handleResult == 3">
        <div class="bbox">
            <div class="bbox-header">
                投诉结果更新
            </div>
            <div class="bbox-content" style="margin-top:22px">处理时间：{{moment(result.handleTime).format('YYYY-MM-DD HH:mm')}}</div>
            <div class="bbox-content" style="margin-top:14px;">经与对方沟通后，已解除封号，对方可正常使用账号。</div>
        </div>
    </div>
    <div v-if="result.handleStatus == 0">
        <img src="../../assets/img/complain/clock.png" alt="" class="img_img">
        <p class="tips">您已投诉该用户，请耐心等待处理结果</p>
    </div>
    <div v-else>
        <div v-if="result.handleResult == 1">
            <div class="bbox">
                <div class="bbox-header">
                    投诉结果反馈
                </div>
                <div class="bbox-content" style="margin-top:22px">处理时间：{{moment(result.handleTime).format('YYYY-MM-DD HH:mm')}}</div>
                <div class="bbox-content" style="margin-top:14px">投诉失败，对方并无违规。</div>
            </div>
        </div>
        <div v-else>
            <div class="bbox">
                <div class="bbox-header">
                    投诉结果反馈
                </div>
                <div class="bbox-content" style="margin-top:22px" v-if="result.handleStatus == 2">处理时间：{{moment(result.handleTime).format('YYYY-MM-DD HH:mm')}}</div>
                <div class="bbox-content" style="margin-top:14px">投诉成功，对方已被{{result.handleRemark}}</div>
            </div>
        </div>
    </div>
    <div class="box">
        <div>
            <div class="box-label">投诉时间</div>
            <div class="box-content">{{moment(result.createdTime).format('YYYY-MM-DD HH:mm')}}</div>
        </div>
        <div>
            <div class="box-label">投诉类型</div>
            <div class="box-content">{{result.complaintType}}{{result.complaintTypeInfo ? '>'+result.complaintTypeInfo : '' }}</div>
        </div>
        <div>
            <div class="box-label">投诉内容</div>
            <div class="box-content">{{result.content}}</div>
        </div>
        <div>
            <div class="box-label">证据图片</div>
            <div class="box-content" style="margin-bottom:0"></div>
        </div>
    </div>
</div>
</template>

<script>
import head from '@/mixins/head';
export default {
    mixins: [ head ],
    data() {
        return {
            title: '投诉结果',
            complaintClassification: '',
            result: {}
            // handleStatus:'', // 0 待处理  1 已处理
            // handleResult:'' // 1 不处理  2封账号
        };
    },
    created() {
        this.complaintClassification = this.$route.params.type;
        this.query();
    },
    methods: {
        query() {
            let params = {
                complaintClassification: this.complaintClassification
            };
            if (this.complaintClassification == 0) {
                params.respondentProfileId = this.$route.params.id;
            } else {
                params.respondentGroupId = this.$route.params.id;
            }
            console.log(params);
            this.$httpAxios.post('/bdsaas/ajax/account/queryComplaintInfo.do', params, {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                transformResponse: [function (data) {
                    return data;
                }]
            })
            .then(res => {
                console.log(res);
                this.result = res.data.data;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    .container{
        background-color: #F5F7FB;
        height: 100%;
        padding-top: 14px;
    }
    .img_img{
        width: 54px;
        height: 54px;
        margin: 54px 160px 27px;
    }
    .tips{
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #242934;
        line-height: 16px;
        margin-bottom: 54px;
    }
    .bbox{
        background: #FFFFFF;
        border-radius: 11px;
        padding-bottom: 27px;
        margin: 0 16px 14px;
        .bbox-header{
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #9CA6B9;
            line-height: 43px;
            padding-left: 16px;
            border-bottom: 1px solid #EDF1F6;
            text-align: left;
        }
        .bbox-content{
            // height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC,Montserrat-Regular,Montserrat;
            font-weight: 400;
            color: #242934;
            line-height: 19px;
            padding-left: 16px;
            text-align: left;
        }
    }
    .box{
        margin: 0 14px;
        padding: 14px 16px 19px;
        background: #FFFFFF;
        border-radius: 11px;
        .box-label{
            height: 12px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9CA6B9;
            line-height: 12px;
            text-align: left;
            margin-bottom: 7px;
        }
        .box-content{
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC, Montserrat-Regular, Montserrat;
            font-weight: 400;
            color: #9CA6B9;
            line-height: 14px;
            text-align: left;
            margin-bottom: 29px;
        }
    }
</style>
